import React from 'react'
import { useTranslation } from 'react-i18next'
import { Select as SelectIcon } from 'assets/images'
import styles from './LanguageSelect.module.scss'

const LANGUAGE_OPTIONS = [
  {
    value: 'en',
    label: 'English',
  },
  {
    value: 'es',
    label: 'Spanish',
  },
]

const LanguageSelect = () => {
  const { i18n } = useTranslation()

  const handleChange = event => {
    i18n.changeLanguage(event.target.value)
  }

  return (
    <div className={styles.container}>
      <div className={styles.select}>
        <select
          id="lang"
          name="lang"
          value={i18n.language}
          onChange={handleChange}
          className={styles.input}
        >
          {LANGUAGE_OPTIONS.map(languageOption => (
            <option key={languageOption.value} value={languageOption.value}>
              {languageOption.label}
            </option>
          ))}
        </select>
        <SelectIcon />
      </div>
    </div>
  )
}

export default LanguageSelect
